import { SxProps, Theme, alpha } from '@mui/material';

const container: SxProps<Theme> = (theme) => ({
  marginTop: 2,
  backgroundColor: alpha(theme.palette.primary.main, 0.05),
});

const boxFrequency: SxProps<Theme> = (theme) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.15),
  border: `1px solid ${theme.palette.primary.light}`,
  borderRadius: 2,
  marginRight: 1,
  paddingX: 1,
  paddingY: 0.25,
});

const date: SxProps<Theme> = {
  fontSize: 12,
  marginLeft: {
    xs: 0,
    sm: 2,
  },
};

const buttonMenu: SxProps<Theme> = {
  '& .MuiMenu-paper': {
    border: '1px solid rgba(0,0,0,0.12)',
  },
};

const styles = {
  container,
  boxFrequency,
  date,
  buttonMenu,
};

export default styles;
